import { render } from "./CryptoRankings.vue?vue&type=template&id=480f85ab&ts=true"
import script from "./CryptoRankings.vue?vue&type=script&lang=ts"
export * from "./CryptoRankings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__